<template>
  <div class="Management">
    <div class="header" style="margin: 10px 0">
      <div class="title">
        <span
          @click="backs"
          style="cursor: pointer; color: #4587ff; margin-right: 20px"
          ><i class="el-icon-arrow-left"></i>返回</span
        >
        专业服务列表
        <el-button type="primary" size="small" @click="add" icon="el-icon-plus"
          >新增</el-button
        >
      </div>
    </div>
    <div
      class="content_list list"
      v-show="dataList.length != 0"
      @scroll="scrollTask"
    >
      <div class="content_box" style="margin-top: 10px">
        <el-alert
          :closable="false"
          title="一个完整的专业服务包括3部分：专业服务基本信息、服务项目、流程节点，添加专业服务时请确保这三部分都已填写完整。"
          type="warning"
        ></el-alert>

        <div
          class=""
          style="border-bottom: 1px #ededed solid"
          v-for="(el, i) in dataList"
          :key="i"
          @click="goDetails(el)"
        >
          <div class="item_apply_box1">
            <div class="num_label">
              <div class="box">{{ i + 1 }}</div>
            </div>
            <div class="practice_name" style="flex: 1">
              <div class="time_box practic">
                {{ el.name || '未填写完成' }}

                <div
                  class=""
                  style="
                    display: flex;
                    color: #326afb;
                    font-weight: 600;
                    cursor: pointer;
                    font-size: 15px;
                    box-sizing: border-box;
                  "
                >
                  <div
                    style="
                      color: #333;
                      font-weight: 600;
                      cursor: pointer;
                      font-size: 15px;
                      margin-right: 20px;
                      box-sizing: border-box;
                    "
                  >
                    编辑
                  </div>
                  <div @click.stop="goServiceItemsPage(el)">服务项目配置</div>
                </div>
              </div>
              <div class="time_box" style="margin: 10px 0">
                {{ el.brief || '暂无简介' }}
              </div>
            </div>
          </div>
          <div class="bot_box_big">
            <div class="time_box">{{ el.createTime }}</div>
            <div class="">
              <div
                class="fun"
                v-if="el.status !== 0"
                @click.stop="changeStatus(el, 0)"
              >
                <img :src="imgUrl + 'suspend_service.png'" mode="" />
                暂停
              </div>
              <div class="fun" v-else @click.stop="changeStatus(el, 1)">
                <img :src="imgUrl + 'firing_img.png'" mode="" />
                启动
              </div>
              <div class="fun" @click.stop="deleteData(el)">
                <img :src="imgUrl + 'editedBooks_del.png'" mode="" />
                删除
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="empty" v-show="dataList.length == 0">
      <img :src="require('assets/images/kong.png')" alt="" />
      <div>暂无任务</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['dataList'],
  data() {
    return {
      imgUrl:
        'https://payment-writemall-com.oss-cn-shenzhen.aliyuncs.com/miniapps/wqzk/',
    }
  },
  methods: {
    scrollTask(e) {
      this.$emit('scrollTask', e)
    },
    deleteData(v) {
      this.$emit('deleteData', v)
    },
    backs(v) {
      this.$emit('backs')
    },
    add() {
      this.$emit('add')
    },
    changeStatus(v, i) {
      this.$emit('changeStatus', v, i)
    },
    goDetails(v) {
      console.log(v)
      this.$emit('goDetails', v)
    },
    goServiceItemsPage(v) {
      this.$emit('goServiceItemsPage', v)
    },
  },
}
</script>

<style lang="scss" scoped>
.Management {
  height: 640px;

  border-radius: 10px;
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 30px;
    .tit_box {
      font-size: 16px;
      font-weight: bold;
      color: #000000;

      display: flex;
      align-items: center;
      justify-content: space-between;
      .tip {
        font-size: 12px;
        font-weight: normal;
        color: #333;
        > text {
          color: #326afb;
        }
      }
    }
    .title {
      position: relative;
      font-size: 16px;
      width: 100%;
      font-family: Microsoft YaHei;
      font-weight: 600;
      color: #333333;
      .el-button {
        position: absolute;
        top: -10px;
        right: 0;
      }
    }
    .more {
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      cursor: pointer;
    }
  }
  .content_list {
    height: calc(100% - 30px) !important;
  }
  .list {
    height: calc(100% - 140px);
    overflow: auto;
    .content_box {
      width: 100%;
      min-height: 150px;
      border-radius: 10px 10px 0 0;
      background-color: #fff;
      padding: 10px 23px calc(env(safe-area-inset-bottom) + 110px);
      box-sizing: border-box;
      .bot_box_big {
        width: 100%;
        min-height: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        margin-bottom: 10px;
        color: #333;
        padding-left: 38px;
        box-sizing: border-box;

        > div {
          display: flex;
          align-items: center;
        }

        .fun {
          cursor: pointer;
          display: flex;
          align-items: center;
          margin-left: 10px;
        }

        .time_box {
          font-size: 13px;
          color: #999999;
        }

        img {
          width: 16px;
          height: 16px;
          margin-right: 5px;
        }
      }
      .practic {
        width: 100%;
        display: flex;
        justify-content: space-between;
      }
      .item_apply_box1 {
        width: 100%;
        padding: 5px 0;
        box-sizing: border-box;
        display: flex;
        align-items: center;

        .practice_name {
          > div:first-child {
            font-weight: 600;
            font-size: 15px;
            color: #222222;
          }

          .time_box {
            font-size: 13px;
            color: #999999;
            margin-top: 10px;
          }
        }
        .num_label {
          display: flex;
          align-items: center;
          margin-right: 18px;

          .box {
            font-size: 15px;
            font-weight: bold;
            color: #326afb;
            width: 21px;
            height: 21px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #f2f6ff;
            border-radius: 50%;
          }
        }
      }
    }
    .list-item {
      display: flex;
      cursor: pointer;
      flex-direction: column;
      gap: 15px;
      margin-bottom: 20px;
      border-bottom: 1px solid #f7f7f7;
      padding: 10px 0;
      .top {
        display: flex;
        align-items: center;
        .index {
          width: 24px;
          height: 24px;
          margin-right: 10px;
          background: #f2f6ff;
          border-radius: 50%;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #326afb;
          // line-height: 15px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .title {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #222222;
          flex: 1;
        }
        .accept {
          width: 79px;
          height: 28px;
          background: #f4f7ff;
          border-radius: 5px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #326afb;
          line-height: 28px;
          padding-left: 20px;
          box-sizing: border-box;
          cursor: pointer;
          position: relative;
          &::after {
            content: '';
            position: absolute;
            width: 7px;
            height: 7px;
            border-radius: 50%;
            background: #326afb;
            top: 50%;
            transform: translateY(-50%);
            left: 8px;
          }
        }
      }
      .center {
        display: flex;
        align-items: center;
        .type,
        .region {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
        }
        .region {
          margin-left: 10px;
        }
        .demand {
          margin-left: 20px;
          flex: 1;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          line-height: 15px;
          // text-align: center;
        }
        .price {
          .unit {
            font-size: 12px;
          }
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ff5346;
          line-height: 15px;
        }
      }
      .bottom {
        .createTime {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
        }
      }
    }
  }
  .empty {
    text-align: center;
    margin: 25% 0;
    img {
      width: 150px;
      height: 150px;
    }
    font-size: 14px;
    color: #999;
    text-align: center;
  }
}
</style>
